export class AuthUserModel{
    
 userId:string;
 userFullName:string;
 facultyId:string;
 hospitalId:string;
 userProgramCategory:number;
 roles:string[];
 userName:string;
 facultyName:string;
 hospitalName:string;
 programCategoryName:string;
 profilePictureSmallUrl:string;

}

